<template>
    <Modal
        v-model="showModal"
        width="450"
        :mask-closable="false"
        class-name="vertical-center-modal"
    >
        <div class="content">
            <i v-if="showIcon" class="iconfont icon">&#xe7f3;</i>
            <Input :style="{'margin-top': showIcon ? null : '30px' }" size="large" v-model="vcodeValue" placeholder="请输入图形验证码"/>
            <div class="imgBox">
                <img :src="vcodeImg" alt style="width: 70%;margin: 0 auto;" @click="refresh" />
            </div>
            
            <p class="alertMsg" v-if="alertMsg">{{alertMsg}}</p>
        </div>
        <div slot="footer">
            <Button type="primary" @click="checkVcode">提交</Button>
        </div>
    </Modal>
</template>

<script>
import { api } from "../api/register.js";
export default {
    props:{
        templetCode:null,
        mateCode:null,
        showIcon: true
  },
    data() {
        return {
            showModal: false,
            mobile: "",
            vcodeImg: "",
            vcodeToken: "",
            vcodeValue: "",
            alertMsg:null
        };
    },
    methods: {
        show(mobile) {
            this.vcodeImg = "";
            this.vcodeValue = "";
            this.alertMsg = null
            this.mobile = mobile;
            this.refresh();
        },
        refresh() {
            api.getVcode()
                .then(v => {
                    this.showModal = true;
                    this.vcodeImg = v.data.data.image;
                    this.vcodeToken = v.data.data.token;
                })
                .catch(v => {
                    console.log(v);
                });
        },
        /**
         * @desc templetCode 短信模板
         * REGISTER-CAPTCHA 注册
         * LOGIN-CAPTCHA    登录
         * FIND-PWD-CAPTCHA 找回密码
         * MODIFY_MOBILE_CAPTCHA 修改手机号
         */
        checkVcode() {
            if(this.vcodeValue.length != 4){
               this.$Message.warning('请输入四位图形验证码') 
               return
            }
            api.checkVcode({
                imgCaptcha: this.vcodeValue,
                imgToken: this.vcodeToken,
                length: 6,
                mobile: this.mobile,
                templetCode:this.templetCode
            },this.mateCode).then(v => {
                if (!v.data.success) {
                    if (v.data.code == 'MSG-001'){
                        this.alertMsg = v.data.msg
                    }else {
                        this.$Message.info(v.data.msg);
                    }
                    return;
                }
                this.alertMsg = null
                this.showModal = false;
                this.$Message.info("发送成功");
                this.$emit("finished", { token: v.data.data });
            });
        }
    }
};
</script>

<style lang="less">
.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999 !important;
    .content {
        margin-top: -9px;
        padding: 0px 60px;
        .imgBox {
            width: 100%;
            border: 1px solid #dddee1;
            border-radius: 4px;
            margin-top: 7px;
        }
    }
    button {
        background: #ff9100;
        border-color: #ff9100;
        width: 50%;
        margin: 0 auto;
        display: block;
    }
    .icon {
        color: #ff9100;
        text-align: center;
        font-size: 35px;
    }
}

.alertMsg {
  margin-top: 10px;
  color: #f00;
}
</style>


// WEBPACK FOOTER //
// vcode.vue?6c8ebd54